import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import AdminPage from "@/pages/AdminPage";
import EditNeedPage from "@/pages/EditNeedPage";
import PastorPage from "@/pages/PastorPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/pastor" element={<PastorPage />} />
          <Route path="/edit/:token" element={<EditNeedPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
